"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_bootstrap_table_next_1 = __importDefault(require("react-bootstrap-table-next"));
const CustomPagination_1 = require("../../../Common/CustomPagination");
const ai_1 = require("react-icons/ai");
const fa_1 = require("react-icons/fa");
const rapidos_api_1 = require("../../../../utils/api/rapidos/rapidos.api");
const TableSkeleton_1 = __importDefault(require("../../AdminShared/TableSkeleton"));
const RapidosAdminTable = ({ search }) => {
    var _a;
    const [page, setPage] = (0, react_1.useState)(1);
    const [perPage, setPerPage] = (0, react_1.useState)(100);
    const { data = { data: [] }, isLoading } = (0, rapidos_api_1.useGetRapidosQuery)();
    const rapidos = (_a = data === null || data === void 0 ? void 0 : data.data) !== null && _a !== void 0 ? _a : [];
    const filteredData = (0, react_1.useMemo)(() => {
        const normalizedSearch = search.trim().toLowerCase();
        if (!normalizedSearch) {
            return rapidos;
        }
        return rapidos.filter((item) => {
            var _a, _b;
            const cardNumber = ((_a = item.card_number) !== null && _a !== void 0 ? _a : "").toString().toLowerCase();
            const cardName = ((_b = item.card_name) !== null && _b !== void 0 ? _b : "")
                .toString()
                .toLowerCase();
            return (cardNumber.includes(normalizedSearch) ||
                cardName.includes(normalizedSearch));
        });
    }, [rapidos, search]);
    const paginatedData = (0, react_1.useMemo)(() => {
        return filteredData.slice((page - 1) * perPage, page * perPage);
    }, [filteredData, page, perPage]);
    const [visibleRows, setVisibleRows] = (0, react_1.useState)(0);
    const [activeId, setActiveId] = (0, react_1.useState)(0);
    const toggleVisibility = (id) => {
        setVisibleRows(id);
        console.log("", id);
    };
    (0, react_1.useEffect)(() => {
        setActiveId(visibleRows);
    }, [visibleRows]);
    (0, react_1.useEffect)(() => {
        console.log("activeId", activeId);
    }, [activeId]);
    (0, react_1.useEffect)(() => {
        setPage(1);
    }, [search]);
    const soldeFormatter = (cell, row) => {
        console.log("cell", cell);
        return (react_1.default.createElement(react_1.default.Fragment, null, activeId === parseInt(row.id) ? (react_1.default.createElement("span", { 
            // onClick={() => toggleVisibility(row.id)}
            style: { cursor: "pointer" } },
            visibleRows,
            " FCFA")) : (react_1.default.createElement("span", { 
            // onClick={() => toggleVisibility(row.id)}
            style: { cursor: "pointer", color: "blue" } }, "Voir solde"))));
    };
    const nameFormatter = (cell, row) => {
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null, row === null || row === void 0 ? void 0 :
                    row.prenom,
                    " ", row === null || row === void 0 ? void 0 :
                    row.nom))));
    };
    const actionFormatter = (cell, row) => {
        return (react_1.default.createElement("div", { className: "table-actions-btn-container-commandes d-flex justify-content-start gap-3" },
            react_1.default.createElement("div", { className: "container-btn-action-icon-modal d-flex justify-content-center" },
                react_1.default.createElement("button", { className: "btn btn-action-modal-icon with-tooltip", "data-tooltip-content": "Voir" },
                    react_1.default.createElement(ai_1.AiFillEye, null))),
            react_1.default.createElement("button", { className: "btn with-tooltip btn-action-icon-delete", "data-tooltip-content": "Supprimer", style: { color: "#E53E3E" } },
                react_1.default.createElement(fa_1.FaTrash, null))));
    };
    const columns = [
        {
            dataField: "card_number",
            text: "Numéro de carte",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "card_name",
            text: "Nom de la carte",
            headerStyle: () => {
                return {
                    width: "300px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
        {
            dataField: "solde",
            text: "Solde",
            formatter: soldeFormatter,
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
            events: {
                onClick: (e, column, columnIndex, row, rowIndex) => {
                    setActiveId(row.id);
                    setVisibleRows(row.solde);
                },
            },
        },
        {
            dataField: "prenom",
            text: "Prénom et Nom",
            headerStyle: () => {
                return {
                    width: "200px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
            formatter: nameFormatter,
        },
        {
            dataField: "id",
            text: "Action",
            formatter: actionFormatter,
            headerStyle: () => {
                return {
                    width: "150px",
                    whiteSpace: "normal",
                    textAlign: "start",
                };
            },
        },
    ];
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "col-lg-12" },
            react_1.default.createElement("div", { className: "admin-table" },
                !!isLoading && react_1.default.createElement(TableSkeleton_1.default, { headers: columns }),
                !isLoading && (react_1.default.createElement(react_1.default.Fragment, null,
                    react_1.default.createElement(react_bootstrap_table_next_1.default, { keyField: "id", data: paginatedData || [], columns: columns, condensed: true, hover: true, wrapperClasses: "table-responsive admin-table" }),
                    react_1.default.createElement("div", { className: "custom-pagination-container" },
                        react_1.default.createElement(CustomPagination_1.CustomPagination, { nbPages: filteredData === null || filteredData === void 0 ? void 0 : filteredData.length, page: page, onChange: (page, perPage) => {
                                setPerPage(perPage);
                                setPage(page);
                            }, perPage: perPage }))))))));
};
exports.default = RapidosAdminTable;
// const data: any[] = [
//     {
//         id: 1,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "2000 FCFA",
//         statut: "Délivrée",
//         payment: "Wave",
//     },
//     {
//         id: 2,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "4000 FCFA",
//         statut: "Délivrée",
//         payment: "Orange Money",
//     },
//     {
//         id: 3,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "24 000 FCFA",
//         statut: "Délivrée",
//         payment: "Wave",
//     },
//     {
//         id: 4,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "2000 FCFA",
//         statut: "En cours",
//         payment: "Wave",
//     },
//     {
//         id: 5,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "2000 FCFA",
//         statut: "Délivrée",
//         payment: "Wave",
//     },
//     {
//         id: 6,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "2000 FCFA",
//         statut: "Délivrée",
//         payment: "Wave",
//     },
//     {
//         id: 7,
//         utilisateur: "ama@gmail.com",
//         date: "Mardi 23 Juin 2025",
//         montant: "2000 FCFA",
//         statut: "Délivrée",
//         payment: "Wave",
//     },
// ];
